var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 171,
    viewBox: "0 0 199 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1861_57110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 85.3059C0 38.1761 44.3748 0 99.0808 0C153.787 0 198.161 38.1761 198.161 85.3059C198.161 132.337 153.787 170.612 99.0808 170.612C44.3748 170.612 0 132.436 0 85.3059Z",
    fill: "#193964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7825 27.6492L109.806 19.9746L109.905 144.44L86.6841 152.312L86.7825 27.6492Z",
    fill: "#EE3235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.367 94.0633C171.202 111.872 161.264 129.878 139.421 129.878C126.729 129.878 116.693 121.22 109.805 110.495V98.0974C118.464 102.427 126.434 106.953 136.273 107.149C148.277 107.346 159.198 102.722 163.724 94.0633H173.367ZM100.458 105.28C102.82 102.427 109.313 93.5714 109.313 93.5714C117.677 82.2563 127.713 66.8088 144.439 66.8088C151.819 66.8088 159.198 70.3509 163.134 76.0576H172.776C169.431 58.347 157.427 41.1284 136.076 41.1284C117.972 41.1284 107.346 52.7387 98.2935 65.5296C97.3096 66.9071 90.8157 75.5656 88.5527 78.5174C80.2878 89.7341 70.547 104.591 54.3123 104.591C43.6859 104.591 33.0596 97.3102 32.8628 86.5855C32.666 71.0396 46.5393 64.1522 62.3804 64.349C69.9566 64.4473 81.5669 67.891 86.7816 71.4332V54.5098C80.5829 47.5239 70.1534 40.9316 59.3303 40.9316C34.4371 40.9316 24.8931 64.4473 24.8931 84.3225C24.8931 104.985 36.9953 129.78 62.5772 129.78C80.7797 129.583 90.4221 117.284 100.458 105.28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1861_57110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199,
    height: 171,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotak);
export default __webpack_public_path__ + "static/media/kotak.58922e3e284c1e02b7c97a9baa01584c.svg";
export { ForwardRef as ReactComponent };